import React from 'react'
import './TitlePage.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'

const TitlePage = ({title}) => {

    return (        
        <h6 className='title titleResponsive'>{title}</h6>
    )
}

export default TitlePage
